import React, { useEffect, useState } from 'react'
import { Button, Nav, Modal, ModalBody, ModalHeader } from 'reactstrap'

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { resetPublicUser } from '../../Redux/Reducers/user'
import { getCookie, removeLocalStorageItem, setCookie } from '../../Helper/cookieHelper'
import { primary_color, success_color } from '../../Helper/uiHelper'

import useMediaQuery from '../../CustomHook/useMediaQuery'
import { BiArrowToLeft, BiArrowToRight } from 'react-icons/bi'
import DesktopNavigation from './DesktopNavigation'
import { LoginForm } from '../Widget/PubliicAuth/PublicLogin'
import Register from '../Widget/PubliicAuth/Register'
import { FaUserCircle } from 'react-icons/fa'
import { setToggleHeaderSideBar } from '../../Redux/Reducers/sideBar'
import { editMode as updateCMSEditMode } from '../../Redux/Reducers/CMS'
import { clearNav, setNav } from '../../Redux/Reducers/navigations'
import { request } from '../../Redux/Sagas/requests/api'
import { checkCMSPermission } from '../../helper'

const PublicHeader = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const isDesktop = useMediaQuery('(min-width:768px)')

  const [collapsed, setCollapsed] = useState(false)
  const headerBackgroundColor = useSelector((state) => state.ThemeOptions.headerBackgroundColor)
  const publicUser = useSelector((state) => state.User.publicUser)
  const editMode = useSelector((state) => state.CMS.editMode)

  const [showLogin, setShowLogin] = useState(false)
  const [showRegister, setShowRegister] = useState(false)
  const isSideBarOpen = useSelector((state) => state?.SideBar?.isHeaderSideBarOpen)
  const token = getCookie('AUTH_TOKEN')

  useEffect(() => {
    dispatch(setToggleHeaderSideBar(false))
    if (!token && publicUser?.email) {
      onLogout()
    }
  }, [])

  const toggleHamburger = () => {
    dispatch(setToggleHeaderSideBar(!isSideBarOpen))
    setCollapsed(!collapsed)
  }

  const onLogout = () => {
    dispatch(resetPublicUser())
    setCookie('AUTH_TOKEN')
    dispatch(clearNav())
    request('get-navigation').then((res) => {
      if (res?.data) {
        dispatch(setNav(res?.data))
        history.push('/book-my-locker-list')
      }
    })
    removeLocalStorageItem('timer')
    dispatch(updateCMSEditMode(false))
  }

  return (
    <>
      <div
        className={` header  d-flex justify-content-center align-items-center ${isDesktop ? 'px-3vw' : ''} ${headerBackgroundColor}`}
        style={{
          height: '60px',
          position: 'sticky',
          top: 0,
          background: 'white',
          zIndex: 1000,
          boxShadow: '0px 0px 25px 0px rgba(4,159,219,0.18)',
        }}>
        {/* <div className='d-flex justify-content-between align-items-center' style={{ width: container_width }}> */}
        <div className='d-flex justify-content-between align-items-center' style={{ width: '100%' }}>
          <div className='logo ml-2'>
            <img
              alt='logo'
              style={{ cursor: 'pointer' }}
              onClick={() => history.push('/')}
              src={`${process.env.REACT_APP_URL}/logo/locker-logo.png`}
              height={isDesktop ? 50 : 27}
            />
          </div>
          {checkCMSPermission() && (
            <Button
              className='mx-1 subtitle1 rounded-pill font-weight-bold'
              style={{
                backgroundColor: editMode ? success_color : primary_color,
                paddingInline: isDesktop ? '2rem' : '1rem',
                borderColor: primary_color,
                borderRadius: '30px',
                width: '15rem',
              }}
              onClick={() => {
                dispatch(updateCMSEditMode(!editMode))
                // history.push('/welcome/login')
              }}>
              Edit CMS
            </Button>
          )}

          {isDesktop ? (
            <div className='position-relative w-100'>
              <DesktopNavigation />
            </div>
          ) : null}

          <Nav className='header-items align-items-center'>
            <div className='pr-2 d-flex align-items-center' style={{ width: 'max-content' }}>
              {!isDesktop ? (
                <div>
                  <button className={`btn h2 p-0`} style={{ color: primary_color, fontSize: '1.5rem' }} onClick={toggleHamburger}>
                    {collapsed ? <BiArrowToRight /> : <BiArrowToLeft />}
                  </button>
                </div>
              ) : null}

              {!publicUser?.email && (
                <>
                  <Button
                    // outline
                    className='ml-3 subtitle1 rounded-pill'
                    // variant='outline-primary' // Change the variant to the desired color
                    onClick={() => {
                      setShowRegister(true)
                    }}
                    style={{
                      borderColor: primary_color,
                      background: 'transparent',
                      paddingInline: isDesktop ? '2rem' : '1rem',
                      color: primary_color,
                      borderRadius: '30px',
                    }}>
                    Register
                  </Button>
                  <Button
                    className='mx-2 subtitle1 rounded-pill'
                    style={{
                      backgroundColor: primary_color,
                      paddingInline: isDesktop ? '2rem' : '1rem',
                      borderColor: primary_color,
                      borderRadius: '30px',
                    }}
                    onClick={() => {
                      history.push('/welcome/login')
                    }}>
                    Login
                  </Button>
                </>
              )}
              {publicUser?.email && (
                <div className='d-flex'>
                  <div
                    className='d-flex align-items-center ml-3 cursor-pointer'
                    onClick={() => {
                      history.push('/profile-update')
                    }}>
                    {publicUser?.photo ? (
                      <img
                        src={process.env.REACT_APP_STORAGE + publicUser?.photo}
                        height={'40px'}
                        width={'40px'}
                        style={{ borderRadius: '100%', objectFit: 'cover' }}></img>
                    ) : (
                      <FaUserCircle style={{ color: primary_color, fontSize: '1.50rem' }} />
                    )}
                    <span className='ml-2 mr-2' style={{ maxWidth: 70, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {publicUser?.first_name}
                    </span>
                  </div>
                  {isDesktop ? (
                    <Button
                      className='mx-2 rounded-pill px-4 subtitle1 font-weight-bold'
                      style={{ backgroundColor: primary_color, borderColor: primary_color, borderRadius: '20px' }}
                      onClick={() => {
                        onLogout()
                      }}>
                      Logout
                    </Button>
                  ) : null}
                </div>
              )}
            </div>
          </Nav>
        </div>
      </div>
      {!isDesktop ? (
        <div>
          <DesktopNavigation isSidebarOpen={collapsed} isSidebar={true} />
        </div>
      ) : null}

      <Modal
        isOpen={showLogin}
        toggle={() => {
          setShowLogin(false)
        }}
        style={{ width: isDesktop ? '30rem' : '95%' }}>
        <ModalHeader
          toggle={() => {
            setShowLogin(false)
          }}>
          <div className='h4 font-weight-bold' style={{ color: primary_color }}>
            Login now!
          </div>
        </ModalHeader>
        <ModalBody>
          <LoginForm onLogin={() => setShowLogin(false)} />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={showRegister}
        toggle={() => {
          setShowRegister(false)
        }}
        style={{ width: isDesktop ? '30rem' : '95%' }}>
        <ModalHeader
          toggle={() => {
            setShowRegister(false)
          }}>
          <div className='h4 font-weight-bold' style={{ color: primary_color }}>
            Register now!
          </div>
        </ModalHeader>
        <ModalBody>
          <Register onRegister={() => setShowRegister(false)} />
        </ModalBody>
      </Modal>
    </>
  )
}

export default PublicHeader
